import "./JoinUs.module.css";
import Header from "@/reusable_sections/Header";
import EntronsEnContact from "./sections/EntronsEnContact";
import Localisation from "./sections/Localisation";
import QuestionsFrQuentes from "./sections/QuestionsFrQuentes";
import Footer from "@/reusable_sections/Footer";
export default function JoinUsPage() {
  return <div>
      <Header />
      <EntronsEnContact />
      <Localisation />
      <QuestionsFrQuentes />
      <Footer />
    </div>;
}